// extracted by mini-css-extract-plugin
export default {"LoadingSpinner":"DecisionLoading_LoadingSpinner","loading-spinner":"DecisionLoading_loading-spinner"};